import { render } from "./BaseRadioGroup.vue?vue&type=template&id=6f242dc7"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=6f242dc7&lang=css"
script.render = render

export default script